module.exports = __webpack_public_path__ + "static/media/janio_logo (no tagline).76f9e71b.svg";